import { createContext, useContext } from 'react';

export type SSRContextType = {
  statusCode?: number;
  url?: string; // for redirects
  headers?: Record<string, string>;
};

export const SSRContext = createContext<SSRContextType | undefined>(undefined);

export const useSSRContext = () => useContext(SSRContext);
